module.exports = __webpack_public_path__ + "static/img/Ward.f4a185b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ward.jpg
// module id = KCdy
// module chunks = 0